import { Dot } from '@app/shared/ui/atoms/Common';
import { DotsColorType, DotsOrientation } from '@app/shared/types/common';
import { cn } from '@app/shared/utils/common';

interface CarouselDotsProps {
  carouselLength: number;
  currentIndex: number;
  colorMode?: DotsColorType;
  orientation?: DotsOrientation;
}

export function CarouselDots({
  carouselLength,
  currentIndex,
  colorMode = 'accent',
  orientation = 'horizontal',
}: CarouselDotsProps) {
  return (
    <div
      className={cn(
        'flex gap-1',
        orientation === 'horizontal' ? 'justify-center' : 'flex-col items-center'
      )}
    >
      {[...Array(carouselLength)].map((_, i) => (
        <Dot
          isCurrent={currentIndex === i}
          key={i}
          colorMode={colorMode}
          orientation={orientation}
        />
      ))}
    </div>
  );
}
